import { gql } from '@apollo/client';

export const ADD_INSTITUTION = gql`
  mutation addInstitution($id: ID!) {
    serviceProvider: addInstitution(id: $id) {
      id
      institutions {
        id
        name
      }
    }
  }
`;
